








































































































































































































































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { stAccountApi } from '@/services/st-api';
import { OnBoardingEditModel } from '@/services/api/nswag/stapiclient_generated';
import {TimeEntryStore} from '@/store/time-entry-store';
import {UserStore} from '@/store/user-module';

@Component({
  components: {},
})
export default class OnBoarding extends Vue {
  loading: boolean = false;
  showOnboarding = true;
  step: number = 1;
  isFreelancer: boolean | null = null;

  onboardingModel: OnBoardingEditModel = OnBoardingEditModel.fromJS({});

  async mounted() {
    this.onboardingModel = await stAccountApi.getOnboardingEditModel();
  }

  absenceChange(){
    if(!this.onboardingModel.useAbsences){
      this.onboardingModel.useTimeAccount = false;
    }
  }

  changeIsFreelancer(val: boolean){
    this.isFreelancer = val;

    if(this.isFreelancer){
      this.onboardingModel.useAbsences = false;
      this.onboardingModel.useOutgoingInvoice = true;
      this.onboardingModel.useTimeAccount = false;
      this.onboardingModel.useRates = true;
    }else{
      this.onboardingModel.useAbsences = true;
      this.onboardingModel.useOutgoingInvoice = true;
      this.onboardingModel.useTimeAccount = true;
      this.onboardingModel.useRates = true;
    }
  }

  async submit() {
    this.loading = true;
    await stAccountApi.saveOnboardingEditModel(this.onboardingModel);
    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    this.step = 4;
    this.loading = false;
  }

  async skipOnboarding() {
    await stAccountApi.skipOnBoarding();
    await this.endOnboarding();
  }

  async endOnboarding() {
    this.showOnboarding = false;
    await UserStore.reloadStore();
    await this.$router.push({ name: 'TimeEntries' })
  }

  async endOnboardingBasicTimeTracking(){
    this.loading = true;
    await stAccountApi.saveOnboardingEditModel(this.onboardingModel);
    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    this.loading = false;
    this.showOnboarding = false;
    await UserStore.reloadStore();
    await this.$router.push({ name: 'TimeEntries' })
  }
}
